import Dependencies from '../utilities/dependencies';
import DependencyManager from '../utilities/dependency-manager';
import Gallery from './gallery';

export default class InfoBox {

	/**
	 * CSS selectors that must exist for this module to run
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getHolderSelectors = () => ['.info-box'];

	/**
	 * Dependencies that this module requires
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getDependencies = () => [Dependencies.libraries.glightbox];

	/**
	 * Runtime injected CSS classes
	 * @see {@link https://docs.fastrackdev.com/front-end-development.html#javascript-development}
	 */
	static getClassList = () => Object.create({});

	/** @type {HTMLElement} */
	holderElement;

	static RESTAURANTS_LAYOUT = 'restaurant';
	static OFFERS_LAYOUT = 'offer';

	static alpineData = null;

	static currentlySelected = null;


	/**
	 * @param {HTMLElement} holderElement
	 */
	constructor(holderElement) {
		this.holderElement = holderElement;
		const gridGap = 21;
		const galleryElement = document.querySelector('.gallery-wrapper');

		document.addEventListener('alpine:init', () => {
			InfoBox.alpineData = Alpine.reactive({
				open: false,
				layout: null,
				height: 0,
				holderElement: this.holderElement,
				offerAppliedHotel: '',
				modelData: null,

				close() {
					this.open = false;
					this.height = 0;
				},

				openGalleryView() {
					let gallery = [];
					this.modelData.slides.forEach(slide => {
						gallery.push({
							'href': slide.image.lg,
							'type': 'image',
							'alt': slide.image.alt,
						});
					});
					const lightbox = GLightbox({
						elements: gallery,
						autoplayVideos: false,
					});
					lightbox.open();
				},

				init() {
					this.$watch('modelData', () => {
						this.$nextTick(() => {
							this.height = this.$root.querySelector('.info-box-content').scrollHeight + gridGap;
							this.$root.scrollIntoView();
						})
					})
					this.$watch('open', () => {
						this.height = this.open ? this.$root.querySelector('.info-box-content').scrollHeight + gridGap : 0;
					})
				}
			});
			Alpine.data('infoBox', () => (InfoBox.alpineData));
		});
		DependencyManager.loadDependencies([Dependencies.libraries.alpine]);
	}

	/**
	 * @param {String} id
	 */
	static isSelected(id) {
		return InfoBox.currentlySelected === id;
	}
}
